import { Pipe, PipeTransform } from '@angular/core';
import { CONSTANTS } from 'src/app/shared/constants/constants';

@Pipe({
  name: 'eventCodeStyle',
})
export class EventCodeStylePipe implements PipeTransform {
  transform(eventCode: string): string {
    const lockedUnitEvent = CONSTANTS.LOCKED_UNIT_EVENT_CODE;
    const onlineEvent = CONSTANTS.ONLINE_DEVICE_EVENT_CODE;
    const alertEvent = CONSTANTS.ALERT_DEVICE_EVENT_CODE;
    const unlockEvent = CONSTANTS.UNLOCK_DEVICE_EVENT_CODE;
    const unKnownEvent = CONSTANTS.UNKNOW_EVENT_UNIT_CODE;

    switch (true) {
      case lockedUnitEvent.includes(eventCode):
        return 'locked-style';
      case unlockEvent.includes(eventCode):
        return 'unlocked-style';
      case alertEvent.includes(eventCode):
        return 'low-battery-style';
      case onlineEvent.includes(eventCode):
        return 'online-style';
      case unKnownEvent.includes(eventCode):
        return 'unknown-style';
      default:
        return 'default-style';
    }
  }
}
